module.exports = __webpack_public_path__ + "static/media/education.0b9e523c.svg";